import { useEffect, useState } from 'react';

// object visibility filter (map, fullscreen, AR camera); pit collision check ignores it
const KEY = 'giss_vis';
export const VIS_KEYS = ['water', 'gas', 'sewer', 'power', 'telecom', 'otherPipes', 'fittings', 'leaks', 'loggers', 'noise', 'pits', 'dims', 'tracks', 'cad'];
const load = () => { try { return { ...Object.fromEntries(VIS_KEYS.map((k) => [k, true])), ...JSON.parse(localStorage.getItem(KEY)) }; } catch { return Object.fromEntries(VIS_KEYS.map((k) => [k, true])); } };
let vis = load();
const subs = new Set();
export const setVis = (p) => { vis = { ...vis, ...p }; localStorage.setItem(KEY, JSON.stringify(vis)); subs.forEach((f) => f(vis)); };
export const getVis = () => vis;
export function useVis() {
  const [v, setV] = useState(vis);
  useEffect(() => { subs.add(setV); return () => subs.delete(setV); }, []);
  return v;
}
export const pipeCat = (p) => (p.type === 'leak' ? 'leaks' : p.type === 'water' || p.type === 'fire' ? 'water' : ['gas', 'sewer', 'power', 'telecom'].includes(p.type) ? p.type : 'otherPipes');
export const fitCat = (f) => (f.type === 'leak' ? 'leaks' : 'fittings');
export const openVis = () => window.dispatchEvent(new Event('giss-vis-menu'));
export const flyTo = (pts, legend = false) => pts.length && window.dispatchEvent(new CustomEvent('giss-fly', { detail: { pts, legend } }));
